import React, { useEffect, useState } from 'react';
import RichTextEditor from '../../../components/Forms/RichTextEditor';
import MediaUpload from '../../../components/Forms/MediaUpload';
import InputField from '../../../components/Forms/InputField';
import { FaTrash, FaAngleDown, FaAngleRight } from "react-icons/fa";
import { ActionButton } from '../../../components/Forms/ActionButton';

const TipsSection = ({ active, tips, errors, setTips }) => {

    const [expandedTipIndex, setExpandedTipIndex] = useState(0);

    const addTip = () => {
        setTips([...tips, {
            title: "",
            description: "",
            media: '',
            stateMedia: null,
            buttonName: "",
            buttonLink: "",
        }]);
        setExpandedTipIndex(tips.length);
    }

    const [clearMedia, setClearMedia] = useState(false);
    
    const updateTip = (index, field, value) => {
        const updatedTips = [...tips];
        updatedTips[index][field] = field === 'buttonLink' ? value.trim() : value;
        setTips(updatedTips);
    };

    const removeTip = (index) => {
        const updatedTips = [...tips];
        updatedTips.splice(index, 1);
        setTips(updatedTips);
    }

    const handleReset = (index) => {
        updateTip(index, 'title', "");
        updateTip(index, 'buttonName', "");
        updateTip(index, 'buttonLink', "");
        updateTip(index, 'description', "");
        updateTip(index, 'media', "");
        updateTip(index, 'stateMedia', null);
        const updatedTips = tips.map((tip, i) =>
            i === index
                ? { title: '', buttonName: '', buttonLink: '', description: '', media: '', stateMedia: null }
                : tip
        );
        setTips(updatedTips);
        setClearMedia(true);
        setTimeout(() => {
            setClearMedia(false);
        }, 500);
    };
    
    const toggleTip = (index) => {
        setExpandedTipIndex(expandedTipIndex === index ? null : index);
    }
    
    return (
        <>
            {tips.map((tip, index) => (
                <div key={index} className="mb-2 border border-navBtn rounded-md">
                    <div className='flex flex-wrap justify-between w-full p-3'>
                        <h1
                            className='cursor-pointer flex items-center'
                            onClick={() => toggleTip(index)}
                        >
                            {expandedTipIndex === index ? <FaAngleDown /> : <FaAngleRight />}
                            &nbsp; Tip {index + 1} of {tips.length}
                        </h1>
                        <div className='flex'>
                            <ActionButton variant="reset" text="Reset" handleSubmit={() => {
                                handleReset(index);
                            }} />
                            {index !== 0 && (
                                <button
                                    type='button'
                                    title="Remove Tip"
                                    className='flex justify-center gap-2.5 items-center px-5 text-xs text-red'
                                    onClick={() => removeTip(index)}
                                >
                                    <FaTrash />
                                </button>
                            )}
                        </div>
                    </div>

                    {expandedTipIndex === index && (
                        <TipDetails
                            active={active}
                            tipData={tip}
                            index={index}
                            updateTip={updateTip}
                            errors={errors[index] || {}}
                            clearMedia={clearMedia}
                        />
                    )}
                </div>
            ))}
            <div className="flex flex-wrap gap-5 w-full font-semibold text-gray-900 justify-end">
                <button
                    type="button"
                    className="flex gap-2.5 items-center px-5 py-2.5 text-base text-center rounded-md bg-navBtn"
                    onClick={addTip}
                >
                    + Add New Tips
                </button>
            </div>
        </>
    );
};

const TipDetails = ({ active, index, tipData, updateTip, errors, clearMedia }) => {

    const handleImageChange = (value) => {
        updateTip(index, 'media', value);
    };

    const handleStateImageChange = (value) => {
        updateTip(index, 'stateMedia', value);
    };

    // const handleReset = () => {
    //     updateTip(index, 'title', '');
    //     updateTip(index, 'buttonName', '');
    //     updateTip(index, 'buttonLink', '');
    //     updateTip(index, 'description', '');
    //     setImageClear(true);
    // };

    // useEffect(() => {
    //     setImageClear(false);
    // }, [imageClear]);

    return (
        <div className='mb-2 border border-navBtn rounded-md p-3'>
            <div className="flex gap-3 w-full mt-2">
                <MediaUpload
                    label="Media Upload Photo"
                    className="h-auto"
                    id="tip-media-upload"
                    imgClassName="rounded-lg"
                    existingImage={tipData.media}
                    setImageUpload={handleImageChange}
                    stateImage={tipData.stateMedia}
                    setStateImageUpload={handleStateImageChange}
                    clearMedia={clearMedia}
                />
                <div className="flex flex-col gap-2 w-full">
                    <div className='flex gap-2 mb-3'>
                        <div className="basis-1/2">
                            <InputField
                                label="Title"
                                value={tipData.title}
                                placeholder="Enter Title"
                                type="text"
                                name="title"
                                onChange={(e) => updateTip(index, e.target.name, e.target.value)}
                                required={active}
                            />
                            {errors.title && <span className="text-red text-sm font-bold">{errors.title}</span>}
                        </div>
                        <div className="basis-1/2">
                            <InputField
                                label="Button Name"
                                value={tipData.buttonName}
                                placeholder="Enter Button Name"
                                type="text"
                                name="buttonName"
                                onChange={(e) => updateTip(index, e.target.name, e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='flex gap-2'>
                        <InputField
                            label="Button Link"
                            value={tipData.buttonLink}
                            placeholder="Enter Button Link"
                            type="text"
                            name="buttonLink"
                            onChange={(e) => updateTip(index, e.target.name, e.target.value)}
                            className="basis-1/2"
                        />
                    </div>
                    <RichTextEditor
                        label="Description"
                        value={tipData.description}
                        placeholder="Enter Description"
                        name="description"
                        onChange={(value) => updateTip(index, 'description', value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default TipsSection;
